import { Action } from "@babylonjs/core"
import React, { useContext } from "react"
import { PlayerContext } from "../../store/PlayerContext"

const countPlusFiveSeconds = (duration: number, progress: number): number => {
  const dur = duration * progress + 5
  return dur > duration ? duration : dur
}

const countMinusFiveSeconds = (duration: number, progress: number): number => {
  const dur = duration * progress - 5
  return dur < 0 ? 0 : dur
}

function ForwardIcon() {
  const context = useContext(PlayerContext)
  return (
    <svg
      
      onClick={() => {
        //console.log("click")
        context.setPlayerContext({
          type: "SET_PLAYER",
          payload: {
            updateProgress: {
              amount: countPlusFiveSeconds(
                context.player.duration ? context.player.duration : 0,
                context.player.progress
              ),
              type: "seconds",
            },
          },
        })
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      version="1.1"
      viewBox="0 0 28 28"
      style={{
        cursor: "pointer",
      }}
    >
      <path
        fill="#23191c"
        d="M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14z"
      ></path>
      <path
        fill="#dad2d2"
        d="M15.156 17.268c0 .644.723 1.017 1.256.651l4.587-3.235a.796.796 0 000-1.296l-4.587-3.236a.794.794 0 00-1.256.644zm-5.9.651l4.588-3.235a.796.796 0 000-1.296l-4.588-3.244C8.724 9.778 8 10.152 8 10.796v6.472c0 .644.724 1.017 1.256.651z"
      ></path>
    </svg>
  )
}

export default ForwardIcon
